export const TLRenewSubscriptionPricingFormName =
  'tl-renew-subscription-pricing';

export enum TLRenewSubscriptionPricingTiersFormFields {
  PricingTiers = 'pricingTiers',
}
